import React from "react";
import HeroSection from "../containers/UIUX/HeroSection";
import Section_one from "../containers/UIUX/Section_one";
import ItsMatter from "../containers/UIUX/whyItsMatter";
import Portfolio from "../containers/UIUX/Portfolio";
import WhyChoose from "../containers/UIUX/WhyChooseUS";
import Technologies from "../containers/UIUX/Tecnology";

const UiUx = () => {
  return (
    <div>
      <HeroSection />
      <Section_one />
      <ItsMatter />
      <Portfolio />
      <div className="bg-gradient-to-b from-[#F2FBFE] to-white">
        <WhyChoose />
        <Technologies />
      </div>
    </div>
  );
};

export default UiUx;
